// ============================================================
// Braval - Microsoft Entra Authentication Configuration
// ============================================================

export const msalConfig = {
    auth: {
        clientId: "af011dca-1a17-4c8b-ac29-c52469b57225",
        authority: "https://login.microsoftonline.com/7700d991-a886-48a2-857f-9c2f6b905ce3",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

// Scopes requested on login -- openid/profile give us basic
// user identity, User.Read lets us display their name
export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"],
};

// Scopes for acquiring an access token to call the Braval API
// (standalone Azure Functions with Easy Auth)
export const apiRequest = {
    scopes: ["api://af011dca-1a17-4c8b-ac29-c52469b57225/access_as_user"],
};
